import { Tooltip, Typography } from "antd";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { ReactComponent as Cross } from "../../../../assets/img/icons/cross.svg";
import { ReactComponent as SearchIcon } from "../../../../assets/img/icons/search.svg";
import World_icon_red from "../../../../assets/img/icons/world.svg";
import World_icon_blue from "../../../../assets/img/icons/world_blue.svg";
import World_icon_green from "../../../../assets/img/icons/world_green.svg";
import SingleContactIcon from "assets/svgs/SingleContactIcon";
import MultiListIcon from "assets/svgs/MultiListIcon";
import classNames from "classnames";

const SearchTerm = (props) => {
  const {
    onRemove,
    isExtended,
    searchTermId,
    searchTerm,
    alternateCall,
    removeCross,
    hideSearchIcon,
    onClick,
    inAdvancedSearch,
    includedKeywords,
    excludedKeywords,
    isToolTip,
    typeSearch,
    showCampaignAsider,
    showIcon,
  } = props;

  const { Paragraph } = Typography;
  const [ellipsisState, setEllipsisState] = useState(false);
  const [addDomainClass, setAddDomainClass] = useState(false);

  useEffect(() => {
    const searchTermArray = searchTerm?.toLowerCase()?.split(" and ");
    if (Array.isArray(searchTermArray)) {
      searchTermArray?.map((term) => {
        if (
          new RegExp(
            "\\.com$|\\.org$|\\.net$|\\.int$|\\.edu$|\\.gov$|\\.mil$|\\.co$|\\.co\\.uk$|\\.pk$|\\.us$|\\.in$"
          ).test(term)
        ) {
          if (!addDomainClass) {
            setAddDomainClass(true);
          }
        } else {
          if (addDomainClass) {
            setAddDomainClass(false);
          }
        }
      });
    }
  }, [searchTerm]);

  return (
    <>
      <Wrapper
        inAdvancedSearch={inAdvancedSearch}
        includedKeywords={includedKeywords}
        className={
          props.style +
          " " +
          (new RegExp(
            "\\.com$|\\.org$|\\.net$|\\.int$|\\.edu$|\\.gov$|\\.mil$|\\.co$|\\.co\\.uk$|\\.pk$|\\.us$|\\.in$"
          ).test(searchTerm) &&
            (window.location.pathname.includes("source") || window.location.pathname.includes("/content/")) &&
            "domain") +
          " " +
          (addDomainClass ? "domain" : "no-domain")
        }
      >
        <div
          className={classNames(`
        ${isToolTip ? "d-block tag-wrapper" : "d-flex flex-nowrap"} 
        ${typeSearch ? "contact-data" : "list-data"}`)}
        >
          {hideSearchIcon ? null : (
            <span
              className={`${
                includedKeywords ? "search-icon-blue" : excludedKeywords ? "search-icon" : "search-icon-green"
              }`}
            >
              <SearchIcon />
            </span>
          )}
          <span
            data-id="qa-search-person"
            // className="item-label"
            {...(props.onClick ? { onClick: onClick } : {})}
            className={`item-label ${isToolTip ? "" : "sidebar-panel"}`}
          >
            {showIcon ? typeSearch ? <SingleContactIcon /> : <MultiListIcon /> : null}
            <span className="hidden-text" data-qa="qa-hidden-term">
              {searchTerm}
            </span>
            {/* {isToolTip ? ( */}
            <Tooltip placement={"bottom"} title={ellipsisState ? searchTerm : undefined}>
              <Paragraph
                style={{ margin: 0 }}
                // ellipsis={{
                //   onEllipsis: setEllipsisState,
                // }}
                data-qa="qa-elipsis-name"
              >
                {searchTerm}
              </Paragraph>
            </Tooltip>
            {/* ) : ( */}
            {/* <div className="cover-label">{searchTerm}</div> */}
            {/* )} */}
          </span>
          <span className="clear-item">
            {props.recommended
              ? ""
              : props.editable === false
              ? ""
              : !removeCross && (
                  <Cross
                    onClick={
                      onRemove
                        ? () => (alternateCall ? onRemove() : onRemove(searchTermId, isExtended))
                        : undefined
                    }
                  />
                )}
          </span>
        </div>
      </Wrapper>
    </>
  );
};

export default SearchTerm;

const Wrapper = styled.div`
  border-radius: 15px;
  background: ${(props) =>
    props?.inAdvancedSearch ? (props?.includedKeywords ? "#e7edff" : "#FFE0E0") : "#e7edff"};
  border: 1px solid #dadada;
  padding: 7px 9px;
  display: inline;
  float: left;
  transition: 0.5s;
  margin-top: 4px;
  margin-right: 7px;
  max-width: calc(100% - 7px);
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding: 4px 6px;
    border-radius: 11px;
  }
  .contact-data {
  }
  &.selectable {
    cursor: pointer;
    padding: 5px 9px;
  }
  &.selected {
    background-color: #001760;
    .item-label {
      color: #fff;
    }
    .search-icon {
      svg {
        path {
          fill: #fff !important;
        }
      }
    }
  }
  &.domain {
    .item-label {
      color: #001760;
      .ant-typography {
        color: #001760;
      }
    }
    .clear-item svg circle {
      fill: #001760;
      fill-opacity: 1;
      opacity: 1;
    }
    .search-icon-blue {
      background-image: url(${World_icon_blue});
      background-size: contain;
      background-repeat: no-repeat;
      background-position: left;
      svg {
        visibility: hidden;
        opacity: 0;
      }
    }
    .search-icon-green {
      background-image: url(${World_icon_green});
      background-size: contain;
      background-repeat: no-repeat;
      background-position: left;
      svg {
        visibility: hidden;
        opacity: 0;
      }
    }
    .search-icon {
      background-image: url(${World_icon_red});
      background-size: contain;
      background-repeat: no-repeat;
      background-position: left;
      svg {
        visibility: hidden;
        opacity: 0;
      }
    }
  }
  &.exclude {
    .item-label {
      color: ${(props) => (props?.includedKeywords ? "#001760" : "#9f0000")};
      .ant-typography {
        color: ${(props) => (props?.includedKeywords ? "#001760" : "#9f0000")};
      }
    }
    .clear-item svg circle {
      fill: ${(props) => (props?.includedKeywords ? "#001760" : "#9f0000")};
      fill-opacity: 1;
      opacity: 1;
    }
    .search-icon svg path {
      fill: ${(props) => (props?.includedKeywords ? "#001760" : "#9f0000")};
    }
  }
  .item-label {
    color: #001760;
    font-size: 14px;
    font-weight: 500;
    font-family: "Roboto";
    float: left;
    line-height: 16px;
    max-width: calc(100% - 58px);
    overflow: hidden;
    white-space: nowrap;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 10px;
      line-height: 12px;
      /* max-width: calc(100% - 40px); */
      max-width: 85%;
    }
    .ant-typography {
      color: #001760;
    }
    .cover-label {
      /* white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%; */
    }

    &.sidebar-panel {
      max-width: 100%;
      display: flex;
    }
    .hidden-text {
      height: 1px;
      max-width: 100%;
      overflow: hidden;
      opacity: 0;
      visibility: hidden;
      white-space: nowrap;
      line-height: 1px;
      padding: 0;
      margin: 0;
      float: left;
      margin-top: -1px;
      display: none;
    }
  }
  .search-icon-blue {
    margin-right: 7px;
    padding-right: 7px;
    float: left;
    border-right: ${(props) => (props?.inAdvancedSearch ? " 1px solid #DADADA" : " 1px solid rgb(218, 218, 218)")};
    padding-top: 0px !important;
    width: auto;
    display: inline;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-right: 5px;
      padding-right: 5px;
    }
    svg {
      float: left;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 10px;
        height: auto;
      }
    }
  }
  .search-icon-green {
    margin-right: 7px;
    padding-right: 7px;
    float: left;
    border-right: ${(props) => (props?.inAdvancedSearch ? " 1px solid #DADADA" : " 1px solid rgb(218, 218, 218)")};
    padding-top: 0px !important;
    width: auto;
    display: inline;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-right: 5px;
      padding-right: 5px;
    }
    svg {
      float: left;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 10px;
        height: auto;
      }
    }
  }
  .search-icon {
    margin-right: 7px;
    padding-right: 7px;
    float: left;
    border-right: ${(props) => (props?.inAdvancedSearch ? " 1px solid #DADADA" : " 1px solid rgb(218, 218, 218)")};
    padding-top: 0px !important;
    width: auto;
    display: inline;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-right: 5px;
      padding-right: 5px;
    }
    svg {
      float: left;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 10px;
        height: auto;
      }
    }
  }
  .clear-item {
    margin-left: 12px;
    float: left;
    cursor: pointer;
    width: auto;
    display: inline;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-left: 7px;
    }
    svg {
      width: 15px;
      height: 16px;
      float: left;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 12px;
        height: auto;
      }
      circle {
        fill: #001760;
        fill-opacity: 1;
        opacity: 1;
      }
    }
  }
  .tag-wrapper {
    max-width: 100%;
    float: left;
  }
`;
